import { render } from "./edit-icon.svg?vue&type=template&id=3a4535a8"
import script from "./edit-icon.svg?vue&type=script&lang=js"
export * from "./edit-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src806/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__